export const EVENT_DATE_TYPE = {
  SINGLE_DAY: "singleDay",
  RANGE_DAYS: "rangeDays",
  NO_DATE: "noDate",
} as const;
